'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Price_web = require('../../Price/Price.web.cjs');
var Price_web_styles = require('./Price.web.styles.cjs');

/**
 * Description added in ProductCard.web.tsx
 */ const Price = ({ ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: Price_web_styles.price,
        children: /*#__PURE__*/ jsxRuntime.jsx(Price_web.Price, {
            ...rest
        })
    });
};

exports.Price = Price;
//# sourceMappingURL=Price.web.cjs.map
